window.clipboard = {
  copy(input) {
    window.navigator.clipboard.writeText(input);
  },
};
